import { IconButton } from '@fountain/fountain-ui-components';
import { Icon, XOutlineIcon } from '@fountain/ripple/icon';
import React, { FC } from 'react';
import { useIntl } from 'react-intl';

import CustomDropzone from 'components/CustomDropzone';
import { FileFieldTitle } from 'containers/DataValidationModal/components/FileField/FileFieldTitle';
import useStyles from 'containers/DataValidationModal/components/FileField/styles';
import { SharedFieldProps } from 'containers/DataValidationModal/components/types';
import { iconLabels } from 'shared/iconLabels';

export interface UploadProps {
  detail: SharedFieldProps['detail'];
  error?: SharedFieldProps['error'];
  handleUpload: (file: File) => void;
  isEditable?: boolean;
  isRequired?: boolean;
  isMobile?: boolean;
  setIsEditable: (value: boolean) => void;
}

export const Upload: FC<UploadProps> = ({
  detail,
  error,
  handleUpload,
  isEditable,
  isMobile,
  isRequired,
  setIsEditable,
}) => {
  const styles = useStyles();
  const intl = useIntl();
  return (
    <>
      <FileFieldTitle
        isRequired={isRequired}
        subtitle={detail.subtitle}
        title={detail.title}
      >
        <IconButton
          aria-label={intl.formatMessage(iconLabels.cancel)}
          className={isEditable ? styles.editCancel : styles.noEditCancel}
          type="button"
          onClick={() => setIsEditable(false)}
        >
          <Icon icon={XOutlineIcon} size="sm" color="neutral-400" />
        </IconButton>
      </FileFieldTitle>
      <CustomDropzone
        isMobile={isMobile}
        error={error}
        onChangeStatus={handleUpload}
      />
    </>
  );
};
